module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn step-container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8 offset-md-2 alert-container-padding-zero"
  }, [_c('alertbar')], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8 offset-md-2 step-body"
  }, [_c('h4', {
    staticClass: "step-header"
  }, [_vm._v(_vm._s(_vm.$t('message.clinic_info.title')))]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('h6', [_vm._v(_vm._s(_vm.$t('message.clinic_info.clinic_name')))])]), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "clinic-name-th"
    }
  }, [_vm._v(_vm._s(_vm.$t('message.clinic_info.clinic_name_th')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.clinic.th.clinic_name),
      expression: "clinic.th.clinic_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "clinic-name-th",
      "placeholder": _vm.$t('message.clinic_info.clinic_name_th')
    },
    domProps: {
      "value": (_vm.clinic.th.clinic_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.clinic.th.clinic_name = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "clinic-name-en"
    }
  }, [_vm._v(_vm._s(_vm.$t('message.clinic_info.clinic_name_en')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.clinic.en.clinic_name),
      expression: "clinic.en.clinic_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "clinic-name-en",
      "placeholder": _vm.$t('message.clinic_info.clinic_name_en')
    },
    domProps: {
      "value": (_vm.clinic.en.clinic_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.clinic.en.clinic_name = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "form-divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('h6', [_vm._v(_vm._s(_vm.$t('message.clinic_info.clinic_detail')))])]), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "clinic-detail-th"
    }
  }, [_vm._v(_vm._s(_vm.$t('message.clinic_info.clinic_detail_th')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.clinic.th.detail),
      expression: "clinic.th.detail"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "clinic-detail-th",
      "placeholder": _vm.$t('message.clinic_info.clinic_detail_th')
    },
    domProps: {
      "value": (_vm.clinic.th.detail)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.clinic.th.detail = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "clinic-detail-en"
    }
  }, [_vm._v(_vm._s(_vm.$t('message.clinic_info.clinic_detail_en')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.clinic.en.detail),
      expression: "clinic.en.detail"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "clinic-detail-en",
      "placeholder": _vm.$t('message.clinic_info.clinic_detail_en')
    },
    domProps: {
      "value": (_vm.clinic.en.detail)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.clinic.en.detail = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "form-divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('h6', [_vm._v(_vm._s(_vm.$t('message.clinic_info.clinic_logo')))])]), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('drop-zone', {
    staticClass: "crop-profile-image-dropzone",
    class: {
      'profile-image-active': _vm.isProfileImage
    },
    attrs: {
      "placeholder": _vm.profileImagePlaceholder
    },
    on: {
      "fileChange": _vm.profileImageFileChange
    }
  }), _vm._v(" "), _c('img', {
    ref: "crop-profile-image",
    staticClass: "crop-profile-image",
    attrs: {
      "src": _vm.profile_image_src
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('h6', [_vm._v(_vm._s(_vm.$t('message.clinic_info.clinic_albums')))])]), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    attrs: {
      "id": "alblum-wrapper"
    }
  }, [_vm._l((_vm.clinic.images), function(img) {
    return (!img.is_active) ? _c('div', {
      key: img.id,
      staticClass: "image-in-alblum-wrapper"
    }, [_c('i', {
      staticClass: "fa fa-2x fa-times remove-image-from-alblum",
      attrs: {
        "aria-hidden": "true"
      },
      on: {
        "click": function($event) {
          _vm.removeImageFromAlblum(img.id)
        }
      }
    }), _vm._v(" "), _c('img', {
      staticClass: "image-in-alblum",
      attrs: {
        "src": img.file_thumb
      }
    })]) : _vm._e()
  }), _vm._v(" "), _c('vue-core-image-upload', {
    class: ['btn', 'btn-primary', 'btn-upload-image'],
    attrs: {
      "crop": false,
      "max-file-size": 5242880,
      "input-of-file": "image",
      "url": _vm.$APP_CONFIG.api.admin.upload_clinicme_alblum()
    },
    on: {
      "imageuploaded": _vm.imageAlblumUploaded
    }
  }, [_c('i', {
    staticClass: "fa fa-2x fa-plus plus-image",
    attrs: {
      "title": "remove image",
      "aria-hidden": "true"
    }
  })])], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "form-divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('h6', [_vm._v(_vm._s(_vm.$t('message.clinic_info.clinic_info')))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-12"
  }, [_c('label', {
    attrs: {
      "for": "bio-th"
    }
  }, [_vm._v(_vm._s(_vm.$t('message.clinic_info.clinic_info_th')))]), _vm._v(" "), _c('ckeditor', {
    attrs: {
      "id": "bio-th",
      "config": _vm.ckeditorConfig
    },
    model: {
      value: (_vm.clinic.th.info),
      callback: function($$v) {
        _vm.clinic.th.info = $$v
      },
      expression: "clinic.th.info"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "editor-lock"
  }, [(_vm.ckeditorConfig.readOnly) ? _c('i', {
    staticClass: "fa fa-lock menu-lock",
    attrs: {
      "aria-hidden": "true"
    }
  }) : _vm._e()])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-12"
  }, [_c('label', {
    attrs: {
      "for": "bio-en"
    }
  }, [_vm._v(_vm._s(_vm.$t('message.clinic_info.clinic_info_en')))]), _vm._v(" "), _c('ckeditor', {
    attrs: {
      "id": "bio-en",
      "config": _vm.ckeditorConfig
    },
    model: {
      value: (_vm.clinic.en.info),
      callback: function($$v) {
        _vm.clinic.en.info = $$v
      },
      expression: "clinic.en.info"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "editor-lock"
  }, [(_vm.ckeditorConfig.readOnly) ? _c('i', {
    staticClass: "fa fa-lock menu-lock",
    attrs: {
      "aria-hidden": "true"
    }
  }) : _vm._e()])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('h6', [_vm._v(_vm._s(_vm.$t('message.clinic_info.video_links')))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-12"
  }, [_c('doctor-array-input', {
    attrs: {
      "dataset": _vm.clinic.th.video_links,
      "description": _vm.$t('message.clinic_info.youtube_link')
    },
    on: {
      "update:dataset": [function($event) {
        _vm.clinic.th.video_links = $event
      }, function (v) { return _vm.clinic.th.video_links = v; }]
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 form-group"
  }, [_c('button', {
    staticClass: "btn btn-cancel btn-lg",
    on: {
      "click": _vm.cancelChange
    }
  }, [_vm._v(_vm._s(_vm.$t('action_message.cancel')))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-store btn-lg",
    on: {
      "click": _vm.saveAndContinue
    }
  }, [_vm._v(_vm._s(_vm.$t('action_message.save')))]), _vm._v(" "), _vm._t("loader")], 2)])])]), _vm._v(" "), _c('sweet-modal', {
    ref: "crop-modal",
    attrs: {
      "overlay-theme": "dark"
    }
  }, [_c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('vue-croppie', {
    ref: "croppieRef",
    attrs: {
      "enableOrientation": true
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 form-group"
  }, [_c('button', {
    staticClass: "btn btn-lg btn-close",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.cancelCrop($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('action_message.cancel')))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-lg btn-success",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.confirmCrop($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('action_message.ok')))])])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-51b3ce8d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/clinic/steps/General.vue
// module id = 1008
// module chunks = 1